import { createElement, memo, useContext } from '@max/max';
const isWeb = true;
import View from '@hfe/max-view';
import Image from '@hfe/max-image';
import Text from '@hfe/max-text';
import './index.scss';
import { GOODS_STATUS } from '../../types';
import Sensor from '@max/mbc-sensor';
import { LX_CONFIG, SHOW_TYPE_ENUM } from '../../constants';
import { adaptScreenWidth } from '../../common-api/utils';
import { useMonitorNavigation } from '@nibfe/mcp-monitor-sdk';
import { navigateToDetailPage } from '../../utils/navigate';
const ShowSize = {
    [SHOW_TYPE_ENUM.SIGNAL_ROW]: 'small',
    [SHOW_TYPE_ENUM.TWO_LIST]: 'normal'
};
const ImageSize = {
    small: {
        width: '314rpx',
        height: '235rpx'
    },
    normal: {
        width: '342rpx',
        height: '256rpx'
    }
};
const MyComponent = (props) => {
    const { headImage, positionInfo, title, price, buyButtonText, salesCount, score, rating, bookInfo, userReview, headIcon, headIconImg, headIconText, headIconTextColor, headIconBackgroundColor, scoreInfoSwitch, bookInfoSwitch, distanceInfoSwitch, salesInfoSwitch, buyButtonTextColor, buyButtonBackgroundColor, status, priceColor, extModel, privilegeTag = false } = props.poiInfo;
    const { showType = SHOW_TYPE_ENUM.TWO_LIST, clickBizLine, poiIdList, poiIdUrlExtraParamsString } = props;
    const { sellPrice, originalPrice, discountInfo } = price || {};
    const ctx = useContext(global?._EngineGlobalContext);
    const { monitorNavigateTo } = useMonitorNavigation();
    const { _LXReport, _moduleId } = ctx;
    const onCardClick = () => {
        const poiId = extModel.poiIdStr || extModel.poiId;
        const shopuuid = extModel.shopUuid;
        const shopIdStr = extModel.shopIdStr;
        if (!poiId || status !== GOODS_STATUS.CAN_SALE || window?.inEditor) {
            return;
        }
        const val_lab = {
            _moduleId: _moduleId ?? '-999',
            poi_id: poiId,
            is_ddt: privilegeTag,
            tex_id: ctx?._runtimeInfo?.queryParams?.pageId ?? '-999',
            custom: {}
        };
        const hotelchannel = ctx?._runtimeInfo?.queryParams?.hotelchannel;
        if (hotelchannel) {
            val_lab.custom.hotel_channel = hotelchannel;
        }
        if (clickBizLine) {
            val_lab.custom.click_biz_line = clickBizLine;
        }
        _LXReport?.mcReportWithTag?.(LX_CONFIG.CARD_MC_BID, {
            valLab: val_lab
        });
        navigateToDetailPage({
            poiId,
            shopuuid,
            hotelchannel,
            shopIdStr
        }, monitorNavigateTo, {
            isNeedAdd: Array.isArray(poiIdList) && poiIdList?.indexOf(poiId?.toString()) > -1,
            extraParamsString: poiIdUrlExtraParamsString
        });
    };
    const onCardShow = () => {
        const poiId = extModel.poiIdStr || extModel.poiId;
        _LXReport?.mvReport(LX_CONFIG.CARD_MV_BID, {
            valLab: {
                _moduleId: _moduleId ?? '-999',
                poi_id: poiId,
                is_ddt: privilegeTag,
                tex_id: ctx?._runtimeInfo?.queryParams?.pageId ?? '-999',
                custom: {
                    hotel_channel: ctx?._runtimeInfo?.queryParams?.hotelchannel ?? '-999',
                    click_biz_line: clickBizLine ?? '-999'
                }
            }
        });
    };
    const hasSaleCount = originalPrice && sellPrice && Number(originalPrice) > Number(sellPrice);
    return <Sensor once onAppear={() => {
        onCardShow();
    }}>
      <View className={`hotel-dynamic-poi-list-card-container-${ShowSize[showType]}`} style={{
        ...props.style,
        ...(isWeb ? {
            boxShadow: '0rpx 3rpx 9rpx 0rpx rgba(0, 0, 0, 0.12)'
        } : showType === SHOW_TYPE_ENUM.TWO_LIST ? {
            width: adaptScreenWidth() ?? '342rpx'
        } : {})
    }} onClick={() => {
        onCardClick();
    }}>
        
        <View className={`hotel-dynamic-poi-list-top-area-${ShowSize[showType]}`}>
          <Image x-if={headImage?.value} style={ImageSize[ShowSize[showType]]} source={{
        uri: headImage.value ? headImage.value.replace('http:', 'https:').replace('/w.h/', '/') + '@684w' : ''
    }}></Image>
          <View x-if={bookInfoSwitch} className="hotel-dynamic-poi-list-book-info-container">
            <Text className="hotel-dynamic-poi-list-book-info">{bookInfo}</Text>
          </View>
          <View x-if={headIcon && headIconText && !headIconImg} style={{
        backgroundColor: headIconBackgroundColor
    }} className="hotel-dynamic-poi-list-head-icon">
            <Text style={{
        color: headIconTextColor
    }} className="hotel-dynamic-poi-list-head-icon-text">
              {headIconText}
            </Text>
          </View>
          <View x-if={headIcon && headIconImg} style={{
        backgroundColor: headIconBackgroundColor
    }} className="hotel-dynamic-poi-list-head-icon-image-container">
            <Image x-if={headIconImg} className="hotel-dynamic-poi-list-head-icon-image-container" source={{
        width: '150rpx',
        height: '12rpx',
        uri: headIconImg
    }}></Image>
          </View>
        </View>
        
        <View className="hotel-dynamic-poi-list-bottom-area">
          <View>
            <Text numberOfLines={2} style={{
        textOverflow: 'ellipsis'
    }} className="hotel-dynamic-poi-list-poi-name">
              {title}
            </Text>
            <View className="hotel-dynamic-poi-list-score-rating-user-review-container">
              <Text x-if={scoreInfoSwitch && score} className="hotel-dynamic-poi-list-score">
                {score}
              </Text>
              <Text x-if={rating} className="hotel-dynamic-poi-list-rating">
                {rating}
              </Text>
              <Text x-if={userReview} numberOfLines={1} className="hotel-dynamic-poi-list-user-review">
                {userReview}
              </Text>
            </View>
          </View>

          <View className="hotel-dynamic-poi-list-price-area">
            <Text x-if={positionInfo && distanceInfoSwitch} numberOfLines={1} className="hotel-dynamic-poi-list-position-info">
              {positionInfo}
            </Text>
            <View className="hotel-dynamic-poi-list-small-tag-container">
              <View x-if={discountInfo} className="hotel-dynamic-poi-list-discount-container">
                <Text className="hotel-dynamic-poi-list-discount-content">{discountInfo}</Text>
              </View>
              <View x-if={salesCount && salesInfoSwitch} className="hotel-dynamic-poi-list-sales-count-container">
                <Text className="hotel-dynamic-poi-list-sales-count-content">{salesCount}</Text>
              </View>
            </View>
            <View className="hotel-dynamic-poi-list-price-wrap">
              <View className="hotel-dynamic-poi-list-sell-price">
                <Text className="hotel-dynamic-poi-list-prev">￥</Text>
                <Text className="hotel-dynamic-poi-list-price" style={{
        color: priceColor,
        fontFamily: isWeb ? 'MTfin-bold2' : 'MTfin-bold2.0'
    }}>
                  {sellPrice}
                </Text>
                <Text className="hotel-dynamic-poi-list-behind">起</Text>
              </View>

              <Text x-if={hasSaleCount} className="hotel-dynamic-poi-list-origin-price">{`￥${originalPrice}`}</Text>
            </View>
            <View className="hotel-dynamic-poi-list-buy-button-wrap" style={{
        backgroundColor: status === GOODS_STATUS.CAN_SALE ? buyButtonBackgroundColor : '#CCCCCC'
    }}>
              <Text className="hotel-dynamic-poi-list-buy-button-text" style={{
        color: status === GOODS_STATUS.CAN_SALE ? buyButtonTextColor : '#999999'
    }}>
                {status === GOODS_STATUS.CAN_SALE ? buyButtonText : '售罄'}
              </Text>
            </View>
          </View>
        </View>
      </View>
    </Sensor>;
};
export default memo(MyComponent);
